export default __webpack_public_path__ + "static/media/Check.ae716add.gif";